import React from "react"

import styles from "./Button.module.scss"

/**
 * @param {String} [className] - additional className to add
 * @param {String} [icon] - fa icon to add before button text
 * @param {String} [iconEnd] - fa icon to add after button text
 * @param {String} text - text to display inside button
 * @param {Function} onClick - function to execute onClick
 * @param {String} [color] - color of the component (primary/secondary/danger); default primary
 * @param {String} [size] - sm/md/lg; default is lg
 * @param {Object} [dropdownToggleRef] - a way to click on the button from outside
 * @param {Boolean} disabled - set cursor to not pointer and no hover and no onClick
 */
const Button = props => {
    const size = props.size || "lg"
    return (
        <div
            className={`${styles.button} ${styles[props.color] || styles.primary} ${styles[`btn-${size}`]} ${props.className || ""} ${props.disabled ? styles["btn-disabled"] : ""}`}
            onClick={props.disabled ? null : props.onClick || null}
            ref={props.dropdownToggleRef || null}
        >
            {props.icon ? <i className={props.icon} /> : ""}
            <span>{props.text}</span>
            {props.iconEnd ? <i className={props.iconEnd} /> : ""}
        </div>
    )
}

export default Button
